import React, { useEffect, useState, useRef } from "react";
import "../styles/IndepDriverInfo.css";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton";
import Utils from "../utils/Utils.js";

function IndepDriverInfo({ onDataChange }) {
  const ownerIDPassportRef = useRef(null);
  const DrivingLicenseRef = useRef(null);
  const VehicleRegistrationRef = useRef(null);
  const [ownerIDPassport, setOwnerIDPassport] = useState({ name: "" });
  const [DrivingLicense, setDrivingLicense] = useState({ name: "" });
  const [VehicleRegistration, setVehicleRegistration] = useState({ name: "" });
  const [DriverName, setDriverName] = useState("");
  const [taxNumber, setTaxNumber] = useState("");

  useEffect(() => {
    onDataChange({
      ownerIDPassport,
      DrivingLicense,
      VehicleRegistration,
      DriverName,
      taxNumber,
    });
  }, [
    ownerIDPassport,
    taxNumber,
    DrivingLicense,
    VehicleRegistration,
    DriverName,
  ]);

  const handleFileChange = async (e, setter) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Only image files are allowed");
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      alert("Max file size is 50MB");
      return;
    }

    try {
      const fileData = await Utils.processImageFile(file, 8);
      setter(fileData);
    } catch (err) {
      alert(err.message);
    }
  };
  return (
    <div className="intddriver-reg-window-container-div">
      <div className="intddriver-reg-info-input">
        <div className="intddriver-reg-info-input-header">
          <div className="intddriver-reg-info-input-header-title">
            Independent Driver Information
          </div>
          <div className="intddriver-reg-info-input-header-text">
            Update the user's basic details
          </div>
        </div>
        <div className="intddriver-reg-info-input-body">
          <div className="intddriver-reg-info-data-input">
            <div className="intddriver-reg-info-data-input-cont">
              Driver Name <div className="required">*</div>
            </div>
            <div className="intddriver-reg-info-input-data">
              <input
                className="intddriver-reg-info-input-data-tag"
                value={DriverName}
                onChange={(e) => setDriverName(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="intddriver-reg-info-data-input">
            <div className="intddriver-reg-info-data-input-cont">
              Tax Number <div className="required">*</div>
            </div>
            <div className="intddriver-reg-info-input-data">
              <input
                className="intddriver-reg-info-input-data-tag"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={taxNumber}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  setTaxNumber(onlyNumbers);
                }}
              ></input>
            </div>
          </div>
        </div>
        <div className="intddriver-reg-info-input-body-doc">
          <div className="intddriver-reg-info-input-body-doc-title">
            Required Documents
          </div>

          {/**********************************************************/}
          <div className="intddriver-reg-info-input-body-doc-data">
            {/*Owner ID/ Passport*/}
            <div className="intddriver-reg-info-input-body-doc-data-rows">
              <div className="intddriver-reg-info-data-input-cont">
                Owner ID/ Passport <div className="required">*</div>
              </div>
              <div
                className="verification-documents-input-container"
                onClick={() => ownerIDPassportRef.current?.click()}
              >
                <div className="verification-documents-icon">
                  <Uploadbutton />
                </div>
                <input
                  type="file"
                  ref={ownerIDPassportRef}
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    try {
                      const fileData = await Utils.processImageFile(file);
                      setOwnerIDPassport(fileData);
                    } catch (err) {
                      alert(err.message);
                    }
                  }}
                />
                <input
                  placeholder="ID or Passport Image"
                  className="verification-documents-input"
                  value={ownerIDPassport.name}
                  readOnly
                />
              </div>
            </div>

            {/*Driving License*/}
            <div className="intddriver-reg-info-input-body-doc-data-rows">
              <div className="intddriver-reg-info-data-input-cont">
                Driving License <div className="required">*</div>
              </div>
              <div
                className="verification-documents-input-container"
                onClick={() => DrivingLicenseRef.current?.click()}
              >
                <div className="verification-documents-icon">
                  <Uploadbutton />
                </div>
                <input
                  type="file"
                  ref={DrivingLicenseRef}
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    try {
                      const fileData = await Utils.processImageFile(file);
                      setDrivingLicense(fileData);
                    } catch (err) {
                      alert(err.message);
                    }
                  }}
                />
                <input
                  placeholder="Certificate Image"
                  className="verification-documents-input"
                  value={DrivingLicense.name}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="intddriver-reg-info-input-body-doc-data-row">
            {/*Vehicle Registration Paper*/}
            <div className="intddriver-reg-info-data-input-cont">
              Vehicle Registration Paper <div className="required">*</div>
            </div>
            <div
              className="verification-documents-input-container"
              onClick={() => VehicleRegistrationRef.current?.click()}
            >
              <div className="verification-documents-icon">
                <Uploadbutton />
              </div>
              <input
                type="file"
                ref={VehicleRegistrationRef}
                style={{ display: "none" }}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  if (!file.type.startsWith("image/")) {
                    alert("Only image files are allowed");
                    return;
                  }

                  if (file.size > 50 * 1024 * 1024) {
                    alert("Max file size is 50MB");
                    return;
                  }
                  try {
                    const fileData = await Utils.processImageFile(file, 8);
                    setVehicleRegistration(fileData);
                  } catch (err) {
                    alert(err.message);
                  }
                }}
              />
              <input
                placeholder="Proof Image"
                className="verification-documents-input"
                value={VehicleRegistration.name}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndepDriverInfo;
